module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "alumni-picker"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/software-img.jpg")
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "need-software"
  }, [_vm._v("Need Software?")]), _vm._v(" "), _c('div', {
    staticClass: "checkboxes"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.needsSoftware),
      expression: "needsSoftware"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "radio",
      "value": "true",
      "id": "yes",
      "name": "needs_software"
    },
    domProps: {
      "checked": _vm._q(_vm.needsSoftware, "true")
    },
    on: {
      "__c": function($event) {
        _vm.needsSoftware = "true"
      }
    }
  }), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.needsSoftware),
      expression: "needsSoftware"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "radio",
      "value": "false",
      "id": "no",
      "name": "needs_software"
    },
    domProps: {
      "checked": _vm._q(_vm.needsSoftware, "false")
    },
    on: {
      "__c": function($event) {
        _vm.needsSoftware = "false"
      }
    }
  }), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right"
  }, [_c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createInvoice()
      }
    }
  }, [_vm._v("Submit")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Your Mentorship at Think Tank Online is over, now what?")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Now that you have wrapped up your Online Mentorship here are some things to think about and some resources to help you take the next steps.")]), _vm._v(" "), _c('h3', [_vm._v("Polish your work")]), _vm._v(" "), _c('p', [_vm._v("Just because your mentorship is over doesn't mean your  portfolio development is done. In fact, you may find that nothing you have worked on thus far is impressive enough to get the attention of the industry you are targeting. The training you have received has given you the tools you need to work independently without the guidance of a mentor or instructor. With that in mind you must make sure your portfolio (demo reel) is at its highest level. In a word, it must be perfect, and more isn't always better. Recruiters will tell you, \"hide the not so good stuff and show them only the gold.” So take the time after your mentorship ends and polish your reel and add new material that elevates your portfolio. If you don't know what “great” looks like, send your work to the Think Tank directors or your supervisor and get some feedback.")]), _vm._v(" "), _c('h3', [_vm._v("Your Mentor isn't dead")]), _vm._v(" "), _c('p', [_vm._v("Nor are they gone.. A great mentor will want to see the end of the story. Which means they will want to see your progress and your final reel. Do what you can to keep the door open with them. Ask if you can continue to send updates from time to time. If they agree, which is likely, send an update every two weeks or so. In this industry networking is huge. It's sometimes not enough to be talented and hardworking. Getting someone to promote and recommend you can make all the difference. Your mentor can be a window to the inside.")]), _vm._v(" "), _c('h3', [_vm._v("Put yourself out there")]), _vm._v(" "), _c('p', [_vm._v("To get attention from studios and recruiters, you must show your work and put yourself out there. We live in a new era where if your work isn’t available online, it just doesn’t exist. Find a platform that best suits your needs and go for it. Artstation is a great website that will help you get the attention you need in the beginning, but you can also use Facebook and Instagram.")]), _vm._v(" "), _c('p', [_vm._v("Make sure to start treating yourself as a brand, and like any other successful brand out there, you must have a place so people can appreciate your work.")]), _vm._v(" "), _c('p', [_vm._v("But only posting your final artwork sometimes isn’t enough to get enough attention, especially in such a competitive area. You must find your way to create original content that will attract attention from other artists and studios. Write about your process, create tutorials, articles, breakdowns, etc.")]), _vm._v(" "), _c('p', [_vm._v("Anything that you can do to contribute to the community will be seen as an active skill by your potential employer. Become a documentarian of what you do.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://portal.tttc.ca/#/kb-article/20"
    }
  }, [_vm._v("Read More")])]), _vm._v(" "), _c('h3', [_vm._v("Software")]), _vm._v(" "), _c('p', [_vm._v("Software is not included in the alumni term but we can provide all your path’s software bundled at a fixed price. If you would like us to purchase this for you, for an additional term length (4 months), submit your choice below:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "yes"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v("Yes, invoice me $485 CAD")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "no"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v("No, I don't need software")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06f3a554!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AlumniPicker.vue
// module id = 1945
// module chunks = 2